export const groupMeReminderOptions = [
  { value: 0, label: 'At event time' },
  { value: 300, label: '5 minutes before' },
  { value: 900, label: '15 minutes before' },
  { value: 1800, label: '30 minutes before' },
  { value: 3600, label: '1 hour before' },
  { value: 7200, label: '2 hours before' },
  { value: 86400, label: '1 day before' },
  { value: 172800, label: '2 days before' },
  { value: 604800, label: '1 week before' },
];

const allowedReminderValues = new Set(groupMeReminderOptions.map((option) => option.value));

export function normalizeGroupMeReminders(value: unknown): number[] {
  if (!Array.isArray(value)) return [];
  const normalized = value
    .map((item) => Number(item))
    .filter((item) => Number.isInteger(item) && allowedReminderValues.has(item));
  return Array.from(new Set(normalized)).slice(0, 2);
}

export function groupMeReminderLabel(value: number): string {
  return groupMeReminderOptions.find((option) => option.value === value)?.label || `${value} seconds before`;
}

export function groupMeReminderSummary(value: unknown): string {
  const reminders = normalizeGroupMeReminders(value);
  if (reminders.length === 0) return 'No reminders';
  return reminders.map(groupMeReminderLabel).join(' + ');
}
